import socketService from "src/core/application/socket.service";

export function useAppSocket() {
    return socketService;
}